import code from "@/plugins/axios/code";
import { PickStr } from "@/types/types";
import { AxiosError, AxiosResponse } from "axios";

interface Response_ {
  status: number;
  code: number;
  message: string;
  body: PickStr<any>;
  type: string;
  determineMessage(): string;
}

class ResponseError extends Error implements Response_ {
  status: number;
  code: number;
  message: string;
  body: PickStr<any>;
  type: string;

  constructor(error: AxiosError) {
    super(error.message);
    this.status = error?.response?.status ?? 500;
    this.code = error?.response?.data?.body?.code ?? 500;
    this.body = error?.response?.data?.body?.data ?? {};
    this.message = this.determineMessage();
    this.type = "Erreur";
  }

  determineMessage(): string {
    return code[this.code] ?? "Erreur inconnue";
  }
}

class ResponseSuccess implements Response_ {
  status: number;
  code: number;
  message: string;
  body: PickStr<any>;
  type: string;

  constructor(response: AxiosResponse<any, any>) {
    this.status = response.status;
    this.code = response.data?.body?.code;
    this.message = this.determineMessage();
    this.type = this.determineType();
    this.body = response?.data?.body?.data ?? {};
  }

  determineMessage(): string {
    return code[this.code] || "Code inconnu";
  }

  determineType(): string {
    const registerCodes = [201, 211, 221, 231];
    const updateCodes = [202, 212, 222, 233];
    const deleteCodes = [203, 213, 232];
    if (registerCodes.includes(this.code)) {
      return "Création";
    }
    if (updateCodes.includes(this.code)) {
      return "Modification";
    }
    if (deleteCodes.includes(this.code)) {
      return "Suppression";
    } else {
      return "Success";
    }
  }
}

export { ResponseSuccess, ResponseError, Response_ };
